export default function ValueProposition() {
  const benefits = [
    {
      icon: "ri-money-dollar-circle-line",
      title: "Reduce Costs by 40%",
      desc: "Smart comparison tools help you find the best agent prices every time, cutting your total purchasing costs dramatically.",
    },
    {
      icon: "ri-speed-up-line",
      title: "Faster QC & Processing",
      desc: "Automated quality control tracking speeds up your workflow so you can focus on what matters: growing your collection.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Better Order Tracking",
      desc: "Never lose track of a shipment again. Our spreadsheet system gives you real-time visibility across all your active orders.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Safer Than Manual",
      desc: "Built-in verification and cross-referencing tools reduce errors and protect you from common agent shopping pitfalls.",
    },
    {
      icon: "ri-bar-chart-box-line",
      title: "Data-Driven Decisions",
      desc: "Comprehensive analytics help you identify the best agents, shipping routes, and buying strategies based on your history.",
    },
    {
      icon: "ri-global-line",
      title: "Multi-Agent Support",
      desc: "Works seamlessly with CSSBuy, Kakobuy, Superbuy, Oopbuy, and all major agent platforms in one unified system.",
    },
  ];

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Why Spreadsheet Shopping Changes Everything
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            The <strong>CSSBuy spreadsheet</strong> approach is transforming how smart buyers interact with agent platforms worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((b) => (
            <div key={b.title} className="bg-background-100/70 rounded-2xl p-6 md:p-7 hover:bg-background-200/70 transition-colors">
              <div className="w-11 h-11 rounded-xl bg-accent-100/70 flex items-center justify-center mb-4">
                <i className={`${b.icon} text-accent-600 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{b.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}